import * as types from './types'

const initialState = {
    list: [],
    condFilters: {},
    total: 0
}
const listBankReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_LIST_BANK:
            return {
                ...state,
                ...action.payload,
                list: action.payload.isScroll 
                    ? [...state.list, ...action.payload.list]
                    : action.payload.list
            }
        case types.RESET_LIST_BANK:
            return initialState
        default:
            return state;
    }

}

export default listBankReducer